import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
export var VenueBlock = function VenueBlock(_ref) {
  var imageUrl = _ref.imageUrl,
      url = _ref.url,
      venue = _ref.venue;
  return React.createElement(Link, {
    className: "venue-block",
    to: url
  }, React.createElement("span", {
    className: "venue-block__text"
  }, venue), imageUrl && React.createElement("div", {
    className: "venue-block__image",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }));
};
VenueBlock.propTypes = {
  imageUrl: PropTypes.string,
  url: PropTypes.string,
  venue: PropTypes.string
};